module.exports = __webpack_public_path__ + "static/img/1-1.48c1f3e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/7/eng/1-1.png
// module id = QasP
// module chunks = 0